<template>
  <div :style="charts19Style" class="sbjkfx">
    <div id="echarts19" :style="charts19Style"></div>
    <div class="right">
      <div class="rightoption clearfix" v-for="(item,index ) in classifyData" :key="index">
        <span class="classifyimg" v-if="index<1"></span>
        <span class="classifyimg classifyimg2" v-else></span>
        <div class="classifyData" @click="classifyquery(item)">{{item}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts19",
  props: {
    charts19Style: {
      type: Object,
      default: () => {
        return { width: "385px", height: "185px", position: "relative" };
      }
    },
    echarts19Data: {
      type: Object,
      default: () => {
        return { name: "最近一周健康评分", value: 89.4 };
      }
    },
    classifyData: {
      type: Array,
      default: () => {
        return ["能源消耗", "故障次数", "设备效率"];
      }
    }
  },
  data() {
    return {};
  },
  mounted() {
    this.pies();
  },
  methods: {
    classifyquery(item) {
      console.log(item)
    },
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(
        document.getElementById("echarts19")
      );
      var option = {
        series: [
          {
            center: ["29%", "60%"], //仪表的位置
            name: "刻度", //仪表的名字
            type: "gauge", //统计图类型为仪表
            radius: "93%", //统计图的半径大小
            min: 0, //最小刻度
            max: 16, //最大刻度
            splitNumber: 7, //刻度数量
            startAngle: 210, //开始刻度的角度
            endAngle: -31, //结束刻度的角度
            axisLine: {
              //设置默认刻度盘上的刻度不显示，重新定义刻度盘
              show: false,
              lineStyle: {
                width: 1,
                color: "transparent"
              }
            }, //仪表盘轴线。
            axisTick: {
              show: true,
              splitNumber: 5, //刻度的段落数
              lineStyle: {
                color: "#216D93",
                width: 1 //刻度的宽度
              },
              length: -12 //刻度的长度
            }, //刻度样式
            splitLine: {
              //文字和刻度的偏移量
              show: true,
              length: -16, //便宜的长度
              lineStyle: {
                color: "#216D93"
              }
            } //分隔线样式
          },
          {
            type: "gauge", //刻度轴表盘
            radius: "90%", //刻度盘的大小
            center: ["29%", "60%"], //刻度盘的位置
            splitNumber: 8, //刻度数量
            startAngle: 215, //开始刻度的角度
            endAngle: -35, //结束刻度的角度
            axisLine: {
              //刻度的线条
              show: true,
              lineStyle: {
                width: 9, //定义一个宽15的数轴
                color: [
                  //颜色为渐变色
                  [
                    0.9,
                    new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: "#5c53de"
                      },
                      {
                        offset: 1,
                        color: "#18c8ff"
                      }
                    ])
                  ],
                  [1, "#413e54"]
                ]
              }
            },
            //分隔线样式。
            splitLine: {
              //表盘上的轴线
              show: false
            },
            axisLabel: {
              //表盘上的刻度数值文字
              show: false
            },
            axisTick: {
              //表盘上的刻度线
              show: false
            },
            pointer: {
              //表盘上的指针
              show: false
            },
            title: {
              //标题\
              show: true,
              offsetCenter: [0, "-26%"], // x, y，单位px
              textStyle: {
                color: "#000",
                fontSize: 16 //表盘上的标题文字大小
              }
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, "16%"],
              color: "#ffffff",
              formatter: function(params) {
                return params;
              },
              textStyle: {
                fontSize: 40,
                shadowColor: "rgba(1, 102, 206, 0.5)",
                shadowBlur: 10,
                color: "#01BA80"
              }
            },
            data: [_this.echarts19Data]
          }
        ]
      };
      var num1 = 0,
        num2 = 0;
      var myInterval = setInterval(function() {
        num1 += Math.round(Math.random()) === 0 ? 0.011 : 0.005;
        num2 += Math.round(Math.random()) === 0 ? 0.011 : 0.005;
        if (num1 >= 1) num1 = 0;
        if (num2 >= 1) num2 = 0;
        option.series[1].axisLine.lineStyle.color = [
          [
            num1,
            new _this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
              {
                offset: 0,
                color: "#90F5D8"
              },
              {
                offset: 0.7,
                color: "#24D19D"
              },
              {
                offset: 1,
                color: "#0A906A"
              }
            ])
          ],
          [1, "#DAF4EB"]
        ];
        behaviorpie.setOption(option);
      }, 30);
      var mytimeout = setInterval(function() {
        clearTimeout(myInterval);
      }, 2800);
    }
  }
};
</script>
<style scoped>
.sbjkfx{
  margin-top: 65px;
  /* margin-left: 110px; */
}
.right {
  position: absolute;
  height: 185px;
  width: 140px;
  right: 10px;
  top: 0;
}
.rightoption {
  width: 100%;
  height: 32px;
  margin: 20px 0;
  display: flex;
  color: #A9925C
}
.classifyimg {
  background: url("../../assets/img/echarts19-1.png") no-repeat;
  width: 31px;
  height: 31px;
  display:block;
  /* margin-right: 5px; */
}
.classifyData {
  height: 32px;
  font-size: 16px;
  margin-left: 10px;
  line-height: 32px;
  font-weight: 500
}
.classifyimg2 {
  background: url("../../assets/img/echarts19-2.png")no-repeat
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts6.vue